import React, { useState, useEffect } from 'react';
import { Radio, Input, Tooltip, Upload } from 'antd';
import { CloseOutlined, PictureOutlined } from '@ant-design/icons';


const ChoixMultiples = ({ options = [], editable = true, onChange, disabled = false , value} ) => {

  const [localOptions, setLocalOptions] = useState(options);

  useEffect(() => {
    setLocalOptions(options);
  }, [options]);

  const handleOptionChange = (value, index) => {
    const updated = [...localOptions];
    updated[index] = value;
    setLocalOptions(updated);
    onChange?.(updated);
  };

  const handleAddOption = () => {
    const updated = [...localOptions, `Option ${localOptions.length + 1}`];
    setLocalOptions(updated);
    onChange?.(updated);
  };

  const handleRemoveOption = (index) => {
     if (index === 0) return;
    const updated = localOptions.filter((_, i) => i !== index);
    setLocalOptions(updated);
    onChange?.(updated);
  };

  return (
    <div  style={{ width: '100%' }}>
      {localOptions?.length > 0 ? (
        localOptions.map((option, index) => (
          <div key={index} style={{ display: 'flex', width: '100%', marginBottom:"4%" }} >

            <Radio name='radio' disabled={disabled} onClick={() => onChange?.({ target: { value: option } })} checked={value === option}  />

            {editable ? (
              <Input
                variant="underlined"
                value={option}
                onChange={(e) => handleOptionChange(e.target.value, index)}
                style={{ width: '90%', marginRight:"1%" }}
              />
            ) : (
              <span>{option}</span>
            )}
            
             {editable && (
                  <Upload ><Tooltip title="Ajouter une image" ><PictureOutlined style={{ fontSize:20 }} /></Tooltip></Upload>
                )}
                {editable && index !== 0 && (
                  <div style={{marginLeft:"2%"}}><Tooltip title="Supprimer"> <CloseOutlined style={{fontSize:20}} onClick={() => handleRemoveOption(index)} /></Tooltip></div>
               )}
          </div>
        ))
      ) : (
        <span style={{ color: '#999', fontStyle: 'italic' }}>Aucune option définie<br/><br/></span>
      )}
      {editable && (
        <Radio  checked={false} value={null} onClick={handleAddOption}>
          Ajouter une option
        </Radio>
      )}
      
    </div>
  );
};

export default ChoixMultiples;
